import React from 'react';

import { getAccHostname } from '@adsk/acs-sc-web-platform-api';
import { EntitlementsProject } from '@adsk/alloy-provider';
import { navigate } from '@adsk/exo-skeleton-api';

import { LinkWithoutColor } from './LinkWithoutColor';
import { getProjectUrlFallback } from '../../utils';
import { getSelectedProduct } from '../../utils/getSelectedProduct';
import { useProductEntryFlowContext } from '../Contexts/ProductEntryFlowContext';

export type TableLinkProps = {
  children: React.ReactNode;
  project: EntitlementsProject;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
};

export const TableLink = ({
  children,
  project,
  onClick,
  ...props
}: TableLinkProps) => {
  const { selectedProductIds } = useProductEntryFlowContext();
  const selectedProductId = selectedProductIds?.[project.id];
  const currentProduct = getSelectedProduct(project, selectedProductId);
  const url =
    currentProduct?.defaultUrl ||
    project.defaultUrl ||
    getProjectUrlFallback(project);

  return (
    <LinkWithoutColor
      {...props}
      data-testid={`row-link-${project.id}`}
      href={url}
      onClick={async (event) => {
        onClick?.(event);

        if (
          event.ctrlKey ||
          event.metaKey ||
          event.button === 1 || // support middle mouse button
          !url.startsWith(getAccHostname())
        ) {
          return;
        } else {
          event.preventDefault();
        }

        await navigate(url);
      }}
    >
      {children}
    </LinkWithoutColor>
  );
};
